// src/App.js
import React from 'react';
import useMeta from '../../hooks/useMeta';

import Navbar from '../../CommonComponent/Navbar/Navbar'; // Importing the Navbar component
import Footer from '../../CommonComponent/Footer/footer';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';


//page component
import PresenceMap from './PageComponent/PresenceMap';

function Presence() {
  useMeta({
    title: 'Presence | Callistus Blinds',
    description: 'Discover premium window treatments at Callistus Blinds. Explore our extensive range of stylish blinds and shades to enhance your home’s aesthetic and comfort.',
    canonical: 'https://callistusblinds.com/presence/',
    og: {
      locale: 'en_US',
      type: 'article',
      title: 'Presence | Callistus Blinds',
      description:
        'Callistus has Authorized Channel Partners spread across the Globe having its Presence in GCC, MENA, USA, Europe, UK, Australia, etc. and expanding.',
      url: 'https://callistusblinds.com/presence/',
      site_name: 'Callistus Blinds',
    },
  });
  return (
    <div>
      <Navbar />
      <NotificationBar />
      <PresenceMap />
      <Footer />
    </div>
  );
}

export default Presence;
